import React from 'react';
import { textBodyLarge, textSerifTitle1 } from '../../styles/typography';
import { PayFitColor } from '../../types/module';

import { applyStyle } from './logic';

export interface KeyFigureProps {
  figure?: string | number;
  description?: string;
  color?: PayFitColor;
  isCard?: boolean;
  hasLineAbove?: boolean;
  isOutlined?: boolean;
  isDark?: boolean;
  size?: 'sm' | 'lg';
}

export const KeyFigure = ({
  color,
  figure,
  isDark,
  isCard,
  size = 'lg',
  isOutlined,
  hasLineAbove,
  description,
}: KeyFigureProps) => (
  <div className={`KeyFigure ${isCard ? 'mb-32' : 'mb-48'}`}>
    <div
      className={applyStyle(
        isCard,
        isDark,
        hasLineAbove,
        color,
        isOutlined,
        size,
      )}
    >
      <span className={textSerifTitle1}>{figure}</span>
      <div className={textBodyLarge}>{description}</div>
    </div>
  </div>
);
